// extracted by mini-css-extract-plugin
export default {"container":"AnonymousApp_container__L2kLa container-fluid","wrapper":"AnonymousApp_wrapper__TFACl","main":"AnonymousApp_main__bIYcc"};